import { buildUrl } from "./utils";

const state = {
  entities: {
    text: {
      root: "/projects/:id/entities/:entityId/text",
    },
    root: "/projects/:id/entities",
  },
};
const actions = {
  get({ rootState: { token } }, { projectId, q } = {}) {
    let url = buildUrl([{ projects: projectId }, { entities: "" }]);
    return this._vm.$http.get(
      url,
      { params: { q }, headers: { Authorization: `Bearer ${token}` } },
    ).then(({ data }) => Promise.resolve(data));
  },
  create({ rootState: { token } }, { projectId, name, color, terms } = {}) {
    const url = buildUrl([
      {
        projects: projectId,
      },
      {
        entities: "",
      },
    ]);

    return this._vm.$http
      .post(
        url,
        {
          name,
          color,
          terms: terms.split("\n"),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then(({ data }) => Promise.resolve(data));
  },
  update(
    { rootState: { token } },
    { projectId, entityId, name, color, terms } = {},
  ) {
    const url = buildUrl([
      {
        projects: projectId,
      },
      {
        entities: entityId,
      },
    ]);
    return this._vm.$http
      .put(
        url,
        {
          name,
          color,
          terms: terms.split("\n"),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then(({ data }) => Promise.resolve(data));
  },
  remove({ rootState: { token } }, { projectId, entityId }) {
    const url = buildUrl([
      {
        projects: projectId,
      },
      {
        entities: entityId,
      },
    ]);
    return this._vm.$http
      .delete(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(({ data }) => Promise.resolve(data));
  },
  updateText(
    { rootState: { token } },
    { projectId, entityId, text, textIndex },
  ) {
    const url = buildUrl([
      {
        projects: projectId,
      },
      {
        entities: entityId,
      },
      {
        text: textIndex,
      },
    ]);
    return this._vm.$http
      .put(
        url,
        {
          text,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then(({ data }) => Promise.resolve(data));
  },
  addToEntity({ rootState: { token } }, { projectId, entityId, text }) {
    const url = buildUrl([
      {
        projects: projectId,
      },
      {
        entities: entityId,
      },
      {
        text: "",
      },
    ]);
    return this._vm.$http
      .post(
        url,
        {
          text,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then(({ data }) => Promise.resolve(data));
  },
  removeFromEntity({ rootState: { token } }, { projectId, entityId, text }) {
    const url = buildUrl([
      {
        projects: projectId,
      },
      {
        entities: entityId,
      },
      {
        text: "",
      },
    ]);
    return this._vm.$http
      .delete(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          text,
        },
      })
      .then(({ data }) => Promise.resolve(data));
  },
};
export default {
  namespaced: true,
  state,
  actions,
};
